
<sm-btn (click)="open(content)" [props]="props"></sm-btn>

<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{ title }}</h4>
        <!-- <button type="button" class="btn btn-close" aria-label="Close" (click)="d('Cross click')"></button> -->
             <button type="button" class="btn-close no-sky-outline" aria-label="Close"
      (click)="d('Cross click')"><span
      aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
        <p>{{ message }}</p>
    </div>
    <div class="modal-footer">
        <sm-btn [props]="props" (click)="onBtnClick($event, c)"></sm-btn>
    </div>
</ng-template>
